export default __webpack_public_path__ + "static/media/Group_Expense.07eacea9.svg";